import React from "react";

import { IgDivider, IgTypography } from "@intelligems/ig-theme";
import { Divider, Grid } from "@mui/material";

import { ConfigType, WidgetDrawerProps } from "../../../types/widgets";

import { AppearanceSettings } from "./AppearanceSettings";
import { PreviewSettings } from "./PreviewSettings";
import { VariableSettings } from "./VariableSettings";
import { VariantSettings } from "./VariantSettings";

type TabContentProps = WidgetDrawerProps & { configType: ConfigType };
export const TabContent = ({
  isTestFlow,
  widgetType,
  widget,
  buttonFocus,
  configType,
}: TabContentProps) => {
  return (
    <Grid item container direction={isTestFlow ? "row" : "column"}>
      <Grid item xs={5}>
        <Grid container item>
          <VariantSettings
            widgetType={widgetType}
            buttonFocus={buttonFocus}
            configType={configType}
          />
        </Grid>
        <Grid item>
          <IgDivider spacing={"s"} />
        </Grid>
        <Grid container item>
          <AppearanceSettings
            widgetType={widgetType}
            buttonFocus={buttonFocus}
            configType={configType}
          />
        </Grid>
        {widgetType === "shippingProgressBar" && (
          <Grid item>
            <IgDivider spacing={"m"} />
          </Grid>
        )}
        <Grid container item>
          <VariableSettings
            widgetType={widgetType}
            buttonFocus={buttonFocus}
            configType={configType}
          />
        </Grid>
      </Grid>
      {isTestFlow && (
        <>
          <Grid item xs={1}>
            <Divider orientation={"vertical"} />
          </Grid>
          <Grid
            xs={6}
            item
            container
            direction={"column"}
            rowSpacing={2}
            className={"bbb!"}
          >
            <Grid item sx={{ marginLeft: "15px" }}>
              <IgTypography sx={{ fontWeight: 600, fontSize: "14px" }}>
                Interface Preview
              </IgTypography>
            </Grid>
            <Grid item sx={{ marginLeft: "15px", marginBottom: "10px" }}>
              <IgTypography sx={{ fontSize: "14px" }}>
                Your selections will appear on your site.
              </IgTypography>
            </Grid>
            <PreviewSettings
              widgetType={widgetType}
              widget={widget}
              buttonFocus={buttonFocus}
              configType={configType}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
